import { Component } from '@angular/core';
import { LivePricesComponent } from './live-prices.component';

@Component({
  selector: 'eid-live-prices-desktop',
  templateUrl: './live-prices.desktop.component.html',
  styleUrls: ['./live-prices.desktop.component.scss']
})
export class LivePricesDesktopComponent extends LivePricesComponent {}
